export default "__VITE_ASSET__Bh4$KSRg__"